import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-790db0df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup_head" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "人数设置", -1))
const _hoisted_3 = { class: "container_rig" }
const _hoisted_4 = { class: "container_rig_one" }
const _hoisted_5 = { class: "container_rig_one" }
const _hoisted_6 = { class: "Concurrent" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Concurrent_t" }, "在线并发限制:", -1))
const _hoisted_8 = { class: "question_mark" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "'0'表示无观看人数上限", -1))
const _hoisted_10 = { class: "Virtual_number" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "Default_base" }
const _hoisted_13 = { class: "question_mark" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "给真实人数添加上固定的虚拟人数。", -1))
const _hoisted_15 = { class: "watch" }
const _hoisted_16 = { class: "watch_input" }
const _hoisted_17 = { class: "question_mark" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("用户每访问频道一次，会在真实访问量上，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("再增加设置的区间值内的随机数。")
], -1))
const _hoisted_19 = { class: "Virtual_number_x" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "v_x" }, "虚拟人数上限:  ", -1))
const _hoisted_21 = { class: "question_mark" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, "默认基础人数 + 观看人数放大 >= 虚拟人数上限，频道将只会增长真实用户访问量。", -1))
const _hoisted_23 = { class: "Final" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "f_z" }, "最终人数:", -1))
const _hoisted_25 = { class: "question_mark" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mask_tip" }, [
  /*#__PURE__*/_createTextVNode("一次性设置频道的当前想要的人数，最低不能低于真实人数，最高不限制，"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 超过真实人数的数量会将超出的人数增加到观看人数放大记录中。")
], -1))
const _hoisted_27 = { class: "tow_o" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "two_t" }, "2. 该数据只为前端用户展现, 后台数据以真实数据统计。", -1))
const _hoisted_29 = { class: "drawer_footer" }
const _hoisted_30 = { class: "btn_group" }

import { ref } from 'vue';
import { QuestionCircleFilled, CloseOutlined } from '@ant-design/icons-vue';
import { Popover, Radio, InputNumber, Button, message } from 'ant-design-vue';
import http from '@/api';
import { useRoute } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'NumberSetting',
  emits: ['click:onCloseLotter'],
  setup(__props, { emit }) {

const aPopover = Popover;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aInputNumber = InputNumber;
const aButton = Button;
const route = useRoute();
// const visible = ref(false)
const onBlack = () => {
  updateOrInsertFalsePeople();
};

const onClose = () => {
  emit('click:onCloseLotter');
};
const Options = ref(1);
const displayMode = ref(1);
const virtualNum = ref(0);
const toplimit = ref(0);
const acquiesce = ref(0);
const minPeople = ref(0);
const maxPeople = ref(0);
const upperLimit = ref(0);
const finalNumber = ref(0);
const pv_number = ref('');
const all = ref(0);
const amplify = ref('');
const falsePeople = () => {
  let falsepeople = {
    studio_id: route.params.studioId,
  };
  http.liveExpress
    .getFalsePeople({ params: falsepeople })
    .then((res) => {
      const degree = res.data.data.body;
      Options.value = degree.people_status;
      displayMode.value = degree.display_mode ? degree.display_mode : 1;
      toplimit.value = degree.concurrency;
      virtualNum.value = degree.status;
      acquiesce.value = degree.default;
      minPeople.value = degree.false_min;
      maxPeople.value = degree.false_max;
      upperLimit.value = degree.max;
      all.value = degree.all;
      pv_number.value = degree.pv_number;
      amplify.value = degree.false;
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};
falsePeople();
const updateOrInsertFalsePeople = () => {
  let update = {
    studio_id: route.params.studioId,
    concurrency: toplimit.value,
    default: acquiesce.value,
    display_mode: displayMode.value,
    false_max: maxPeople.value,
    false_min: minPeople.value,
    max: upperLimit.value,
    people_status: Options.value,
    status: virtualNum.value,
    final_people: finalNumber.value,
  };
  http.liveExpress
    .getupdateOrInsertFalsePeople(update)
    .then((res) => {
      if (res.data.code == 200) {
        message.destroy();
        message.success(res.data.message);
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};
const changeNum = () => {
  if (finalNumber.value < 0) {
    finalNumber.value = 0;
  }
};

const onEmpty = () => {
  http.pagedirect
    .delData({ params: { studio_id: route.params.studioId } })
    .then((res) => {
      message.success(res.data.message);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: "timing_return",
        onClick: onClose
      }, [
        _createVNode(_unref(CloseOutlined))
      ])
    ]),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _createTextVNode(" 人数显示设置:   "),
        _createVNode(_unref(aRadioGroup), {
          value: Options.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((Options).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(aRadio), {
              value: 0,
              class: "one"
            }, {
              default: _withCtx(() => [
                _createTextVNode("开启")
              ]),
              _: 1
            }),
            _createVNode(_unref(aRadio), { value: 1 }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createTextVNode(" 人数显示模式:   "),
        _createVNode(_unref(aRadioGroup), {
          value: displayMode.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((displayMode).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(aRadio), {
              value: 1,
              class: "one"
            }, {
              default: _withCtx(() => [
                _createTextVNode("实时在线(并发)")
              ]),
              _: 1
            }),
            _createVNode(_unref(aRadio), { value: 2 }, {
              default: _withCtx(() => [
                _createTextVNode("用户量(UV)")
              ]),
              _: 1
            }),
            _createVNode(_unref(aRadio), { value: 3 }, {
              default: _withCtx(() => [
                _createTextVNode("累计访问量(PV,支持放大)")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("li", _hoisted_6, [
        _hoisted_7,
        _createVNode(_unref(aInputNumber), {
          id: "inputNumber",
          value: toplimit.value,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((toplimit).value = $event)),
          min: 0,
          max: 10000000,
          class: "current_input",
          parser: (value) => value.replace(/[^0-9]/g, '')
        }, null, 8, ["value", "parser"]),
        _createElementVNode("p", _hoisted_8, [
          _createVNode(_unref(aPopover), { placement: "right" }, {
            content: _withCtx(() => [
              _hoisted_9
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("li", _hoisted_10, [
        _createTextVNode(" 虚拟人数开关:   "),
        _createVNode(_unref(aRadioGroup), {
          value: virtualNum.value,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((virtualNum).value = $event)),
          class: "number_open"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(aRadio), { value: 0 }, {
              default: _withCtx(() => [
                _createTextVNode("开启")
              ]),
              _: 1
            }),
            _createVNode(_unref(aRadio), { value: 1 }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      (!virtualNum.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("li", _hoisted_12, [
              _createTextVNode(" 虚拟基础人数:   "),
              _createVNode(_unref(aInputNumber), {
                id: "inputNumber",
                value: acquiesce.value,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((acquiesce).value = $event)),
                min: 0,
                max: 10000000,
                class: "base_input",
                parser: (value) => value.replace(/[^0-9]/g, '')
              }, null, 8, ["value", "parser"]),
              _createTextVNode("人 "),
              _createElementVNode("p", _hoisted_13, [
                _createVNode(_unref(aPopover), { placement: "right" }, {
                  content: _withCtx(() => [
                    _hoisted_14
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("li", _hoisted_15, [
              _createTextVNode(" 人数放大公式:    "),
              _createElementVNode("p", _hoisted_16, [
                _createVNode(_unref(aInputNumber), {
                  id: "inputNumber",
                  value: minPeople.value,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((minPeople).value = $event)),
                  min: 0,
                  max: 10000000,
                  class: "input_number",
                  parser: (value) => value.replace(/[^0-9]/g, '')
                }, null, 8, ["value", "parser"]),
                _createTextVNode(" -  "),
                _createVNode(_unref(aInputNumber), {
                  id: "inputNumber",
                  value: maxPeople.value,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((maxPeople).value = $event)),
                  min: 0,
                  max: 1000,
                  class: "input_number",
                  parser: (value) => value.replace(/[^0-9]/g, '')
                }, null, 8, ["value", "parser"])
              ]),
              _createTextVNode(" 人 "),
              _createElementVNode("p", _hoisted_17, [
                _createVNode(_unref(aPopover), { placement: "right" }, {
                  content: _withCtx(() => [
                    _hoisted_18
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("li", _hoisted_19, [
              _hoisted_20,
              _createVNode(_unref(aInputNumber), {
                id: "inputNumber",
                value: upperLimit.value,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((upperLimit).value = $event)),
                min: 0,
                max: 10000000,
                class: "number_input",
                parser: (value) => value.replace(/[^0-9]/g, '')
              }, null, 8, ["value", "parser"]),
              _createTextVNode(" 人 "),
              _createElementVNode("p", _hoisted_21, [
                _createVNode(_unref(aPopover), { placement: "right" }, {
                  content: _withCtx(() => [
                    _hoisted_22
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("li", _hoisted_23, [
              _hoisted_24,
              _createVNode(_unref(aInputNumber), {
                id: "inputNumber",
                value: finalNumber.value,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((finalNumber).value = $event)),
                min: 0,
                max: 10000000,
                class: "f_n",
                parser: (value) => value.replace(/[^0-9]/g, ''),
                onChange: changeNum
              }, null, 8, ["value", "parser"]),
              _createTextVNode(" 人 "),
              _createElementVNode("p", _hoisted_25, [
                _createVNode(_unref(aPopover), { placement: "right" }, {
                  content: _withCtx(() => [
                    _hoisted_26
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("li", _hoisted_27, [
              _createTextVNode(" 注: "),
              _createElementVNode("p", null, " 1. 显示观众人数(" + _toDisplayString(all.value) + ") =  真实观众(" + _toDisplayString(pv_number.value) + ") +  默认观众人数(" + _toDisplayString(acquiesce.value) + ") +  观看人数放大(" + _toDisplayString(amplify.value) + ")； ", 1)
            ]),
            _hoisted_28
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_unref(aButton), {
          class: "mod_modal_btn",
          onClick: onClose
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(aButton), {
          class: "mod_modal_btn mod_type_primary",
          onClick: onBlack
        }, {
          default: _withCtx(() => [
            _createTextVNode("保存")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})